import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LEASE_TERMS, MOVE_IN_DATES } from 'util/constants';
import H1 from 'components/deprecated/legacyElements/H1';
import RadioGroup from 'components/RadioGroup';
import { update } from 'actions/onboarding';

import styles from './style.module.scss';

export class TimeframesPage extends PureComponent {
  static propTypes = {
    update: PropTypes.func.isRequired,
    leaseTerm: PropTypes.string.isRequired,
    moveInDate: PropTypes.string.isRequired,
  };

  onChange = (evt) =>
    this.props.update({ [evt.target.name]: evt.target.value });

  render() {
    return (
      <div>
        <H1>What are your timelines?</H1>
        <p>
          Choose a lease term and when you&rsquo;re looking to move into your
          new office.
        </p>

        <h3>Lease Term</h3>
        <RadioGroup
          name="leaseTerm"
          value={this.props.leaseTerm}
          onChange={this.onChange}
        >
          {Object.keys(LEASE_TERMS).map((key) => (
            <option key={key} value={key}>
              {LEASE_TERMS[key]}
              {key === 'THREE_TO_FIVE_YEARS' && (
                <span>The industry average for typical lease terms</span>
              )}
            </option>
          ))}
        </RadioGroup>
        <p className={`micro ${styles.information}`}>
          * Typical lease terms: the industry average for lease terms are
          usually around 3-5 years.
        </p>

        <h3>Move-in Date</h3>
        <RadioGroup
          name="moveInDate"
          value={this.props.moveInDate}
          onChange={this.onChange}
        >
          {Object.keys(MOVE_IN_DATES).map((key) => (
            <option key={key} value={key}>
              {MOVE_IN_DATES[key]}
              {key === 'THREE_TO_SIX_MONTHS' && (
                <span>The average time from search to close</span>
              )}
            </option>
          ))}
        </RadioGroup>
        <p className={`micro ${styles.information}`}>
          * Move-in times: the search to close process will take around 2-4
          months.
        </p>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    leaseTerm: state.onboarding.leaseTerm,
    moveInDate: state.onboarding.moveInDate,
  }),
  {
    update,
  }
)(TimeframesPage);
